const escapeHtmlAttr = (value: string): string =>
  value
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;")

const blockMathHtml = (latex: string): string =>
  `<div data-type="block-math" data-latex="${escapeHtmlAttr(latex)}"></div>`

const inlineMathHtml = (latex: string): string =>
  `<span data-type="inline-math" data-latex="${escapeHtmlAttr(latex)}"></span>`

const BLOCK_MATH_PATTERN = /\\\[([\s\S]*?)\\\]|\$\$([\s\S]*?)\$\$/g

const formatInlineText = (text: string): string => {
  let segment = text.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")

  segment = segment.replace(/\\\(([\s\S]*?)\\\)/g, (_, latex: string) =>
    inlineMathHtml(latex.trim())
  )

  segment = segment.replace(/\$(?!\d+\$)(.+?)\$(?!\d)/g, (_, latex: string) =>
    inlineMathHtml(latex.trim())
  )

  return segment.replace(/\n/g, "<br>")
}

/**
 * Convert OCR text containing LaTeX delimiters into TipTap-compatible HTML.
 * Supports `\[...\]`, `$$...$$`, `\(...\)`, and `$...$`.
 */
export const normalizeOcrLatexForTiptap = (content: string): string => {
  if (!content.trim()) {
    return ""
  }

  const normalized = content.replace(/\r\n|\r/g, "\n")
  const parts: string[] = []
  let lastIndex = 0

  for (const match of normalized.matchAll(BLOCK_MATH_PATTERN)) {
    const matchIndex = match.index ?? 0

    if (matchIndex > lastIndex) {
      const textSegment = formatInlineText(normalized.slice(lastIndex, matchIndex))
      if (textSegment.trim()) {
        parts.push(`<p>${textSegment}</p>`)
      }
    }

    const latex = (match[1] ?? match[2] ?? "").trim()
    if (latex) {
      parts.push(blockMathHtml(latex))
    }

    lastIndex = matchIndex + match[0].length
  }

  if (lastIndex < normalized.length) {
    const textSegment = formatInlineText(normalized.slice(lastIndex))
    if (textSegment.trim()) {
      parts.push(`<p>${textSegment}</p>`)
    }
  }

  return parts.join("")
}
